import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';
import { DropdownService } from '../../services/dropdown.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit, OnDestroy {
  showingMenu = false;
  hasFocus = false;
  private dropdownSubscription: Subscription;
  @Input() required: any;
  @Input() choice = {};
  @Input() key: any;
  @Input() label: any;
  @Input() options: any;
  @Output() selectedDropdownItem = new EventEmitter<Object>();

  constructor(
    private elementRef: ElementRef,
    private dropdownService: DropdownService
  ) {}

  ngOnInit(): void {
    this.dropdownSubscription = this.dropdownService.documentClicked.subscribe(
      (target) => this.handleClick(target)
    );
  }

  ngOnDestroy(): void {
    this.dropdownSubscription.unsubscribe();
  }

  handleClick = (target) => {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.showingMenu = false;
    }
  };

  onBlur = (e) => {
    this.hasFocus = false;
    if (
      e.relatedTarget?.className &&
      e.relatedTarget?.className.includes('menu-option')
    ) {
    } else {
      this.showingMenu = false;
    }
  };

  onMenuOptionKeypress = (option, e) => {
    if (e.code === 'Enter') {
      this.select(option);
    }
  };

  onDropdownKeypress = (e) => {
    if (e.code === 'Enter') {
      this.showingMenu = !this.showingMenu;
    }
  };

  showMenu = () => {
    this.showingMenu = true;

    // make sure dropdown fits vertically within visible viewport
    let elements = this.elementRef.nativeElement.children[0].children;
    let menu = elements[1];
    if (menu === undefined) {
      setTimeout(() => {
        this.showMenu();
      }, 10);
    } else {
      let rect = menu.getBoundingClientRect();
      if (rect.y + rect.height > window.innerHeight) {
        let bottom = rect.y + rect.height;
        menu.style.top = window.innerHeight - bottom + 'px';
      }
    }
  };

  select = (option) => {
    this.choice = option;
    this.showingMenu = false;
    this.selectedDropdownItem.emit(option);
  };
}
